export const CONTENT_SUBMISSION_MODAL_PATH = 'content_submission_modal';
